import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Forklift, ScanLine, Search, Menu } from 'lucide-react';

// Barra fija inferior (<768px) con las 4 acciones que el operario pulsa a diario:
// Entrada · Escanear · Buscar · Más (abre el menú completo). Respeta env(safe-area-inset-bottom).
export function BottomBar({ rol, abrirMenu }) {
  const { t } = useTranslation();
  const esOp = ['owner', 'admin', 'operario'].includes(rol);
  if (!esOp) return null;

  const items = [
    { to: '/entrada', key: 'entrada', icon: Forklift },
    { to: '/escanear', key: 'escanear', icon: ScanLine },
    { to: '/buscar', key: 'buscar', icon: Search },
  ];

  return (
    <nav className="bottombar no-print" data-testid="bottombar">
      {items.map((i) => (
        <NavLink key={i.to} to={i.to} end className={({ isActive }) => `bb-item ${isActive ? 'activo' : ''}`} data-testid={`bb-${i.key}`}>
          <i.icon size={22} strokeWidth={2} />
          <span className="bb-lbl">{t(`nav.${i.key}`)}</span>
        </NavLink>
      ))}
      <button className="bb-item" onClick={abrirMenu} data-testid="bb-mas">
        <Menu size={22} strokeWidth={2} />
        <span className="bb-lbl">{t('nav.mas', 'Más')}</span>
      </button>
    </nav>
  );
}
